import { Pipe, PipeTransform } from '@angular/core';
import { abbr } from '../../utils/abbr';

@Pipe({
  name: 'abbr',
  standalone: false
})
export class AbbrPipe implements PipeTransform {
  public transform(value: string, maxLetters: number = 2): string {
    const words = value.split(' ');
    let result = '';
    for (let index = 0; index < words.length && index < maxLetters; index++) {
      result += abbr(words[index])[0];
    }
    return result;
  }
}
